import type { LngLatLike } from 'mapbox-gl'

export const ZOOM_SPEED = 2.5
export const ZOOM_MIN = 4
export const ZOOM_MAX = 15
export const ZOOM_MARKER = 13

// Center of Queensland
export const INITIAL_CENTER: LngLatLike = [144.0848, -22.5752]

// Source and layer IDs
export const ID_DATA_SOURCE = 'marker-data'
export const ID_CLUSTERS_LAYER = 'clusters'
export const ID_MARKERS_LAYER = 'markers'
